module.exports = __webpack_public_path__ + "static/media/Logo_H.de798ceb.png";